// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import Enums from '../Enums';

export class QuoteRevisionOrigin {
  readonly source: Enums.QuoteRevisionSource;
  readonly createdAt: DateTime;
  readonly createdBy: string | null;
  readonly escalationDate: DateTime | null;
  readonly increaseKind: Enums.EscalationKind | null;
  readonly increaseAmount: string | null;

  constructor(data: { [key: string]: any } = {}) {
    this.source = data.source === undefined ? Enums.QuoteRevisionSource.Original : data.source;
    this.createdAt = DateHelpers.ParseServerDateTime(data.createdAt);
    this.createdBy = data.createdBy === undefined ? null : data.createdBy;
    this.escalationDate = DateHelpers.ParseServerNullableDate(data.escalationDate);
    this.increaseKind = data.increaseKind === undefined ? null : data.increaseKind;
    this.increaseAmount = data.increaseAmount === undefined ? null : data.increaseAmount;
  }

  static zero(): QuoteRevisionOrigin {
    const zeroValues: ExcludeMethodsDeep<QuoteRevisionOrigin> = {
      source: Enums.QuoteRevisionSource.Original,
      createdAt: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
      createdBy: null,
      escalationDate: null,
      increaseKind: null,
      increaseAmount: null,
    };
    return new QuoteRevisionOrigin(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type QuoteRevisionOriginWireFormat = {
  source: string;
  createdAt: string;
  createdBy: string | null;
  escalationDate: string | null;
  increaseKind: string | null;
  increaseAmount: string | null;
};

type NewQuoteRevisionOriginProps = PartialDeep<QuoteRevisionOrigin, { recurseIntoArrays: true }>;
export const NewQuoteRevisionOrigin: (props: NewQuoteRevisionOriginProps) => QuoteRevisionOrigin = (
  props,
) => new QuoteRevisionOrigin(props);

type NewQuoteRevisionOriginFromWireFormatProps = PartialDeep<
  QuoteRevisionOriginWireFormat,
  { recurseIntoArrays: true }
>;
export const NewQuoteRevisionOriginFromWireFormat: (
  props: NewQuoteRevisionOriginFromWireFormatProps,
) => QuoteRevisionOrigin = (props) => new QuoteRevisionOrigin(props);
